import { render, staticRenderFns } from "./standard-select.vue?vue&type=template&id=1e3a1cd9"
import script from "./standard-select.vue?vue&type=script&lang=js"
export * from "./standard-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports